import React from "react";
import "./AgendaComponent.scss";

const AgendaComponent = ({
  title = "Schedule",
  items = [
    { time: "9.00 AM",  label: "Groom's entrance" },
    { time: "9.15 AM",  label: "Poruwa" },
    { time: "12.00 PM", label: "Lunch" },
    { time: "3.30 PM",  label: "Going away" },
  ],
}) => {
  return (
    <section className="agenda" aria-label="Wedding Agenda">
      <div className="agenda__inner">
        <h2 className="agenda__title">{title}</h2>

        <ol className="agenda__list">
          {items.map((it, i) => (
            <li key={i} className="agenda__item">
              <div className="agenda__time">{it.time}</div>
              <div className="agenda__dot" aria-hidden="true" />
              <div className="agenda__label">{it.label}</div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default AgendaComponent;
